import React, { useMemo } from 'react';
import { Button, Form, Input, PopConfirm, Table, useAsync } from '@maxtropy/components';
import { DndContext, type DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { FIELDS } from '@/pages/AssetInformationManagement/constant';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import DragRow from '@/pages/WorkShopOverviewConfig/components/DragRow';
import { BarsOutlined, PlusOutlined } from '@ant-design/icons';
import { v4 as uuid } from 'uuid';

//字段配置的modal里面的,当字段类型为enum时, 需要一个可编辑且可拖拽排序的table
interface SortCustomizeTable {
  enumList: any[];
  setEnumList: (item: any) => void;
  disabled: boolean;
}

const getColumns = ({ enumList, remove }: { enumList: any[]; remove: Function }) => [
  {
    title: '',
    width: 20,
    render: () => (
      <BarsOutlined style={{ fontSize: 20 }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
    ),
  },
  {
    title: '枚举项名称',
    dataIndex: 'name',
    width: 300,
    // ellipsis: { showTitle: true },
    render: (_: any, record: any, index: number) => {
      return (
        <Form.Item
          style={{ marginBottom: 0 }}
          // name={[FIELDS.ENUM_ITEM_LIST, index, FIELDS.ENUM_ITEM_NAME]}
          name={[FIELDS.ENUM_ITEM_LIST, index, 'name']}
          rules={[
            { message: '请输入枚举项名称', required: true },
            { max: 20, message: '最多输入20个字符' },
            {
              validator: (_, name) => {
                const exists = enumList.some((item: any) => item.id !== record.id && item.name === name);
                return exists ? Promise.reject('枚举项已存在') : Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="请输入" style={{ width: '100%' }} />
        </Form.Item>
      );
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 80,
    render: (_: any, record: any, index: number) => {
      return (
        <PopConfirm
          placement="top"
          title={'是否删除该内容？删除后对应页面数据展示也将删除。'}
          onConfirm={() => {
            remove(record.id);
          }}
        >
          <Button type="link" danger>
            删除
          </Button>
        </PopConfirm>
      );
    },
  },
];

export const SortCustomizeTable: React.FC<SortCustomizeTable> = ({ enumList = [], setEnumList, disabled }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    })
  );

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active && over && active?.id && over?.id) {
      const oldIndex = enumList.findIndex((i: any) => i.id === active.id);
      const newIndex = enumList.findIndex((i: any) => i.id === over.id);
      if (oldIndex === undefined || newIndex === undefined || oldIndex === -1 || newIndex === -1) {
        return;
      }
      const newList = [...enumList];
      const [movedItem] = newList.splice(oldIndex, 1);
      newList.splice(newIndex, 0, movedItem);
      setEnumList(newList);
    }

    // console.log('DragEndEvent-active', active);
    // console.log('DragEndEvent-over', over);
  };

  const add = () => {
    const newItem = {
      // id: crypto.randomUUID(),
      id: uuid(),
      name: undefined,
    };
    const newList = [...enumList, newItem];
    setEnumList(newList);
  };

  const remove = (id: number) => {
    const arr = enumList.filter((i: any) => i.id !== id);
    setEnumList(arr);
  };

  const columns = getColumns({ enumList, remove });

  console.log('hook-table', enumList);

  return (
    <>
      <DndContext sensors={sensors} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
        <SortableContext
          items={enumList.map((i: any) => i.id)}
          strategy={verticalListSortingStrategy}
          disabled={disabled}
        >
          <Form.Item
            noStyle
            name={FIELDS.ENUM_ITEM_LIST}
            valuePropName="dataSource"
            rules={[{ validator: (_, value) => (value?.length ? Promise.resolve() : Promise.reject('请添加枚举项')) }]}
            wrapperCol={{ span: 24 }}
            // style={{ width: '100%' }}
            // className={style.sortTable}
          >
            <Table
              components={{
                body: {
                  row: DragRow,
                },
              }}
              rowKey="id"
              columns={columns}
            />
          </Form.Item>
        </SortableContext>
      </DndContext>
      <Button
        type="dashed"
        ghost
        icon={<PlusOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}
        wrapClassName="addRowBtn"
        style={{ width: '100%' }}
        onClick={add}
      >
        添加枚举项
      </Button>
      {/* 校验报错 */}
      <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
        {({ getFieldsError }) => {
          const errors = getFieldsError([FIELDS.ENUM_ITEM_LIST]);
          if (errors.length > 0) {
            return (
              <div style={{ margin: '4px 0 15px 0' }}>
                {errors.map(({ errors }, index) => (
                  <div key={index} className="ant-form-item-explain ant-form-item-explain-error">
                    {errors[0]}
                  </div>
                ))}
              </div>
            );
          }
          return null;
        }}
      </Form.Item>
    </>
  );
};
